import { PlatformSiteAri } from '@atlassian/ari';

import { ActivitiesObjectType as ActivitiesObjectTypeV3 } from '../homeViewsQueryHelpers.ts';

import type { ActivitiesObjectType } from './__types__/HomeRecentWorkQuery.ts';
import { HomeRecentWorkQuery } from './HomeRecentWorkQuery.graphql.ts';

export const getRecentWorkQueryOptions = ({
	cloudId,
	isLoggedIn,
	isWhiteboardViewedEnabled = false,
	isDatabaseEnabled = false,
	isSlidesEnabled = false,
	first = 10,
}: {
	cloudId: string;
	isLoggedIn: boolean;
	isWhiteboardViewedEnabled?: boolean;
	isDatabaseEnabled?: boolean;
	isSlidesEnabled?: boolean;
	first?: number;
}) => ({
	query: HomeRecentWorkQuery,
	variables: {
		cloudId: PlatformSiteAri.create({ siteId: cloudId }).toString(),
		first,
		after: '',
		objectTypes: [
			ActivitiesObjectTypeV3.PAGE,
			ActivitiesObjectTypeV3.BLOGPOST,
			ActivitiesObjectTypeV3.EMBED,
			ActivitiesObjectTypeV3.CONTENT,
			...(isWhiteboardViewedEnabled ? [ActivitiesObjectTypeV3.WHITEBOARD] : []),
			...(isDatabaseEnabled ? [ActivitiesObjectTypeV3.DATABASE] : []),
			...(isSlidesEnabled ? [ActivitiesObjectTypeV3.SLIDE] : []),
		] as ActivitiesObjectType[] | null,
	},
	skip: !isLoggedIn,
});
